import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAlt } from '@fortawesome/pro-solid-svg-icons';
import { faSortAmountUp, faSortAmountDown } from '@fortawesome/pro-solid-svg-icons';

import DealCell from 'bundles/apex/deals/cell';
import { ASC, useSortableRecordContext } from 'hooks/use_sortable_record_state';

export default function DealHeaders({ orderedColumns, sortable }) {
  const { sortCol, sortDir, toggleSort } = useSortableRecordContext();
  return (
    <tr>
      {orderedColumns.map((column, index) => {
        let content = column.label;
        if (sortable) {
          let icon = faSortAlt;
          if (sortCol === column.key) {
            icon = sortDir === ASC ? faSortAmountUp : faSortAmountDown;
          }
          content = (
            <span className="clickable" onClick={() => toggleSort(column.key)}>
              {content} <FontAwesomeIcon icon={icon}/>
            </span>
          );
        }
        return (
          <DealCell className={index === 0 ? 'sticky-cell' : undefined} header key={column.key} name={column.key}>
            {content}
          </DealCell>
        );
      })}
    </tr>
  );
}

DealHeaders.propTypes = {
  orderedColumns: PropTypes.array.isRequired,
  sortable: PropTypes.bool,
};
